export default __webpack_public_path__ + "static/footer-logo-ca454f2e243c400d2d3b40660b6bf769.svg";